<template>
  <div class="home">

    <b-navbar fixed="top" toggleable="lg" type="light">
      <b-navbar-brand href="#"><img src="../assets/img_logo_negro.svg" alt=""></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="#inicio">Inicio</b-nav-item>
          <b-nav-item href="#nosotros">Nosotros</b-nav-item>
          <b-nav-item href="#modelos">Modelos</b-nav-item>
          <b-nav-item href="#recomienda-y-gana">R&G</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item class="btn-contacto" href="#contacto">Contacto</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-container fluid id="inicio" class="banner">
      <b-row class="banner-section align-items-center">
          <b-col md="6" lg="7" sm="12">
            <h1 class="mt-5 mb-5">Lo mejor<br> para tí</h1>
            <h3>No esperes más,<br>haz tu cita hoy</h3>
          </b-col>
          <b-col md="6" lg="5" sm="8" style="position: relative;">
            <div class="form-banner-wrapperout">
              <div class="form-banner-wrapper">
                <h4 class="text-center">Cotiza tu nuevo hogar</h4>
                <p class="error" v-if="messageSendBanner">{{ messageSendBanner }}</p>
                <b-form-input class="mb-2" id="input-1" v-model="nameBanner" placeholder="Nombre" type="text"></b-form-input>
                <b-form-input class="mb-2" id="input-2" v-model="emailBanner" placeholder="Email" type="text"></b-form-input>
                <b-form-textarea class="mb-2" id="input-3" v-model="messageBanner" placeholder="Mensaje" rows="6" max-rows="3"></b-form-textarea>
                <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
                <b-button class="btn btn-enviar-banner" v-on:click="sendMessageBanner">Enviar mensaje</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
    </b-container>

    <b-container class="nosotros text-center" style="position: relative;">
      <div id="nosotros" style="position: absolute; top: -100px;"></div>
      <p class="highlight">Nosotros</p>
      <p><strong>Desde nuestros inicios, nos dedicamos a transformar la forma en que se vive el hogar. Creemos que una vivienda es más que un espacio físico: es la expresión de estilo, valores y aspiraciones.</strong></p>
      <p>Con experiencia en residenciales de alto y medio nivel, fusionamos arquitectura moderna y funcional con ubicaciones que potencian la calidad de vida. Cada proyecto reafirma nuestro compromiso con la calidad, el diseño y el valor duradero.</p>
    </b-container>

    <b-container class="modelos mb-5" style="position: relative;">
      <div id="modelos" style="position: absolute; top: -150px;"></div>
      <b-row>
        <b-col md="12">
          <p class="highlight mb-5">Modelos</p>
        </b-col>
        <b-col class="mb-4" lg="6">
          <div class="wrapper-modelo" v-on:mouseover="duna=true" v-on:mouseout="duna=false">
            <div v-show="duna" style="position: absolute; width: 100%; height: 100%; background: #000; opacity: 0.3; border-radius: 15px;"></div>
            <img class="img-fluid" src="../assets/modelo_duna.png" alt="">
            <b-button v-on:mouseover="duna=true" v-on:click="mostrarModelo('duna')" v-show="duna">Ver modelo</b-button>
          </div>
        </b-col>

        <b-col class="mb-4" lg="6">
          <div class="wrapper-modelo" v-on:mouseover="sierra=true" v-on:mouseout="sierra=false">
            <div v-show="sierra" style="position: absolute; width: 100%; height: 100%; background: #000; opacity: 0.3; border-radius: 15px;"></div>
            <img class="img-fluid" src="../assets/modelo_sierra.png" alt="">
            <b-button v-on:mouseover="sierra=true" v-on:click="mostrarModelo('sierra')" v-show="sierra">Ver modelo</b-button>
          </div>
        </b-col>

        <b-col class="mb-4" lg="6">
          <div class="wrapper-modelo" v-on:mouseover="valle=true" v-on:mouseout="valle=false">
            <div v-show="valle" style="position: absolute; width: 100%; height: 100%; background: #000; opacity: 0.3; border-radius: 15px;"></div>
            <img class="img-fluid" src="../assets/modelo_valle.png" alt="">
            <b-button v-on:mouseover="valle=true" v-on:click="mostrarModelo('valle')" v-show="valle">Ver modelo</b-button>
          </div>
        </b-col>

        <b-col class="mb-4" lg="6">
          <div class="wrapper-modelo" v-on:mouseover="rio=true" v-on:mouseout="rio=false">
            <div v-show="rio" style="position: absolute; width: 100%; height: 100%; background: #000; opacity: 0.3; border-radius: 15px;"></div>
            <img class="img-fluid" src="../assets/modelo_rio.png" alt="">
            <b-button v-on:mouseover="rio=true" v-on:click="mostrarModelo('rio')" v-show="rio">Ver modelo</b-button>
          </div>
        </b-col>
      </b-row>
      <div ref="bottomEl" style="position: absolute; margin-top: -100px;"></div>
      <b-row class="modelo mt-5" v-if="modelo!=''" :key="modelo.nombre">
        <b-col class="mb-4 modelo-slider" lg="7">
          <VueSlickCarousel v-bind="slickOptions" :arrows="true" :dots="false">
            <div v-for="fachada in modelo.fachadas" v-bind:key="fachada.nombre">
              <img class="img-fluid" :src="fachada.img" alt="">
              <p class="fachadaNombre">{{ fachada.nombre }}</p>
            </div>
          </VueSlickCarousel>
        </b-col>
        <b-col class="mb-4" lg="5">
          <p class="highlight">{{ modelo.nombre }}</p>
          <p><strong>Descripción:</strong></p>
          <p>{{ modelo.descripcion }}</p>
          <p><strong>Características:</strong></p>
          <p v-html="modelo.caracteristicas"></p>
          <b-row>
            <b-col v-if="modelo.plantaBaja" md="6">
              <p><strong>Planta Baja:</strong></p>
              <p v-html="modelo.plantaBaja"></p>
            </b-col>
            <b-col v-if="modelo.plantaAlta" md="6">
              <p><strong>Planta Alta:</strong></p>
              <p v-html="modelo.plantaAlta"></p>
            </b-col>
            <b-col v-if="modelo.planta" md="12">
              <p><strong>Planta:</strong></p>
              <p v-html="modelo.planta"></p>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="modeloimgs text-center" md="12">
          <p class="interiores">Interiores</p>
          <VueSlickCarousel class="interiores" :arrows="true" :dots="false" ref="c1" :asNavFor="$refs.c2" :focusOnSelect="true">
            <div v-for="img in modelo.imgs" v-bind:key="img">
              <img class="img-fluid" :src="img" alt="">
            </div>
          </VueSlickCarousel>
          <VueSlickCarousel :arrows="true" :dots="false" ref="c2" :asNavFor="$refs.c1" :slidesToShow="7"  :focusOnSelect="true">
            <div v-for="img in modelo.imgs" v-bind:key="img">
              <img class="img-fluid" :src="img" alt="">
            </div>
          </VueSlickCarousel>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="folleto">
      <b-row>
        <b-col class="text-center mb-3" lg="12">
          <div class="folleto-div">
            <img class="img-fluid mb-3" src="../assets/folleto2.png" alt="">
            <br>
            <b-button v-b-modal.modal-center>Ver folleto</b-button>
          </div>
        </b-col>
        <b-modal id="modal-center" size="xl" hide-header hide-footer centered>
          <b-row class="folleto-wrapper">
            <b-col class="folleto-col1" lg="6">
                  <p>Descarga toda la información acerca de nuestro proyecto y modelos.</p>
                  <p class="error" v-if="messageSendFolleto">{{ messageSendFolleto }}</p>
                  <b-form-input class="mb-1" id="input-1-f" v-model="nameFolleto" placeholder="Nombre:" type="text"></b-form-input>
                  <b-form-input class="mb-1" id="input-2-f" v-model="emailFolleto" placeholder="Email:" type="text"></b-form-input>
                  <b-form-input class="mb-1" id="input-3-f" v-model="phoneFolleto" placeholder="Teléfono:" type="text"></b-form-input>
                  <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
                  <b-button class="btn btn-download" v-on:click="sendDownload('pdf/Folleto.pdf', 'Folleto')">Descargar <img src="../assets/img_flecha_desc.svg"></b-button>
            </b-col>
            <b-col class="folleto-col2" lg="6">
              <img class="img-fluid" src="../assets/img_folleto.png">
            </b-col>
          </b-row>
        </b-modal>
      </b-row>
    </b-container>

    <b-container fluid class="assets">
      <b-row>
        <b-col>
          <p class="highlight">Coto Club</p>
          <p>Descubre el estilo de vida dentro de Coto Club</p>
          <VueSlickCarousel v-bind="slickOptions" :arrows="true" :dots="false">
            <div>
              <img class="img-fluid" src="../assets/coto_club/cotoclub1.png" alt="">
            </div>
            <div>
              <img class="img-fluid" src="../assets/coto_club/cotoclub2.png" alt="">
            </div>
            <div>
              <img class="img-fluid" src="../assets/coto_club/cotoclub3.png" alt="">
            </div>
            <div>
              <img class="img-fluid" src="../assets/coto_club/cotoclub4.png" alt="">
            </div>
            <div>
              <img class="img-fluid" src="../assets/coto_club/cotoclub5.png" alt="">
            </div>
            <div>
              <img class="img-fluid" src="../assets/coto_club/cotoclub6.png" alt="">
            </div>
            <div>
              <img class="img-fluid" src="../assets/coto_club/cotoclub7.png" alt="">
            </div>
          </VueSlickCarousel>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="acceso">
      <b-row>
        <b-col>
          <p class="highlight">Acceso controlado</p>
          <img class="img-fluid" src="../assets/img_acceso.png" alt="">
        </b-col>
      </b-row>
    </b-container>

    <b-container class="recomienda" style="position: relative;">
      <div id="recomienda-y-gana" style="position: absolute; top: -100px;"></div>
      <b-row>
        <b-col>
          <p class="highlight">Recomienda y Gana</p>
          <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSe14sklc-3uBBxoYkI3nLGjhfVDpTzINNUCdSVkMrJ55SkmfQ/viewform"><img class="img-fluid" src="../assets/img_rg.png" alt=""></a>
        </b-col>
      </b-row>
    </b-container>

    <div class="contacto" style="position: relative;">
      <div id="contacto" style="position: absolute; top: -100px;"></div>
      <b-container>
        <b-row>
          <b-col lg="6">
            <div class="form-wrapper">
              <h2>Contáctanos</h2>
              <img class="mb-5" src="../assets/icn_flecha.png" alt="">
              <p class="subtitle">Conoce más acerca de nuestros servicios</p>
              <p class="error" v-if="messageSend">{{ messageSend }}</p>
              
              <b-form-input class="mb-2" id="input-1" v-model="name" placeholder="Nombre" type="text"></b-form-input>
              <b-form-input class="mb-2" id="input-2" v-model="email" placeholder="Email" type="text"></b-form-input>
              <b-form-textarea class="mb-2" id="input-3" v-model="message" placeholder="Mensaje" rows="6" max-rows="3"></b-form-textarea>
              <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
              <b-button class="btn btn-enviar-w mt-4 mb-5" v-on:click="sendMessage">Enviar mensaje</b-button>
            </div>
          </b-col>
          <b-col  lg="6">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3458.1821407692028!2d-115.4236337!3d32.582766!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d777002a10bb83%3A0x5ed35921003c161e!2sCOTO%20SUR%202%20RESIDENCIAL!5e1!3m2!1ses-419!2smx!4v1769807657560!5m2!1ses-419!2smx" width="100%" height="370" style="border:0; margin-bottom: 30px;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            <p class="contact-text"><img src="../assets/icn_ubicacion.svg" alt=""> Av. Río San Francisco 3701, Local 2</p>
            <!-- <p class="contact-text"><img src="../assets/icn_phone.svg" alt=""> 686 520 0493</p> -->
            <p class="contact-text"><img src="../assets/Whatsapp.svg" alt="">  686 192 4713</p>
            <p class="contact-text"><img src="../assets/icn_reloj.svg" alt=""> Lunes a Viernes de 9 am a 7 pm <br>
                Sábado de 9 am a 6 pm <br>
                Domingo 10 am a 5 pm <br></p>
          </b-col>
          <b-col class="social-media mt-4" offset-lg="6" lg="6">
            <a href="https://www.facebook.com/CotoSurPrivadaResidencial"><img src="../assets/icn_facebook.svg" alt=""></a>
            <a href="https://www.instagram.com/cotosurprivadaresidencial/"><img src="../assets/icn_instagram.svg" alt=""></a>
            <a href="https://wa.link/b6dnil"><img src="../assets/icn_whatsapp.svg" alt=""></a>
          </b-col>
      </b-row>
      </b-container>
    </div>
    <b-container class="footer">
      <b-row>
        <b-col lg="2" class="text-center mb-2">
          <img src="../assets/img_logo_negro.svg" alt="">
        </b-col>
        <b-col lg="10" class="text-center">
          <p>Imágenes ilustradas para pauta publiitaria, pueden variar con el producto final.</p>
          <p>Los precios están sujetos a cambios sin previo aviso. Aplica restricciones.</p>
          <p>Coto Sur Residencial. Todos los derechos reservados.</p>
          <p class="aviso"><a target="_blank" href="https://www.cotosur.mx/wp-content/uploads/2022/07/AvisoDePrivacidad.pdf">Aviso de privacidad.</a></p>
        </b-col>
      </b-row>
    </b-container>
    <div class="whatsapp">
          <a href="https://wa.link/b6dnil" target="_blank">
              <img src="../assets/whatsapp.png" alt="Whatsapp">
          </a>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


export default {
  name: 'Home',
  components: { VueSlickCarousel },
  props: {
    
  },
  data() {
      return {
          rio: false,
          duna: false,
          sierra: false,
          valle: false,
          activeModel: false,
          modelo: '',
          modelos: {
            rio: {
              nombre: 'Modelo Río',
              descripcion: 'Hermosa casa con todo lo que necesitas. Favor de contactar a un asesor para más información acerca de los acabados que se entregan.',
              caracteristicas: '<ul><li>Construcción: 120.42 m2</li><li>Terreno: 126 m2</li></ul>',
              plantaAlta: '<ul><li>Recámara principal con walking closet, baño privado y dos lavados</li><li>2 recámaras secundarias</li><li>Baño completo</li></ul>',
              plantaBaja: '<ul><li>Sala</li><li>Cocina</li><li>Comedor</li><li>Medio baño</li><li>Área de lavado interior</li><li>Patio trasero</li><li>Estacionamiento 2 autos</li></ul>',
              imgs: [
                require('../assets/rio/riointbig1.png'),
                require('../assets/rio/riointbig2.png'),
                require('../assets/rio/riointbig3.png'),
                require('../assets/rio/riointbig4.png'),
                require('../assets/rio/riointbig5.png'),
                require('../assets/rio/riointbig6.png'),
                require('../assets/rio/riointbig7.png'),
              ],
              fachadas: [
                { img:require('../assets/rio/imgrioa.png'),
                  nombre: 'Fachada Río A'
                },
                { img:require('../assets/rio/imgriob.png'),
                  nombre: 'Fachada Río B'
                },
                { img:require('../assets/rio/imgrioc.png'),
                  nombre: 'Fachada Río C'
                }
              ]
            },
            duna: {
              nombre: 'Modelo Duna',
              descripcion: 'Hermosa casa con todo lo que necesitas. Favor de contactar a un asesor para más información acerca de los acabados que se entregan.',
              caracteristicas: '<ul><li>Construcción: 64.66 m2</li><li>Terreno: 126 m2</li></ul>',
              planta: '<ul><li>Sala</li><li>Cocina</li><li>Comedor</li><li>Jardín central</li><li>Área de lavado interior</li><li>Recámara principal con terraza</li><li>Recámara secundaria</li><li>Amplios espacios para closets</li><li>Baño</li></ul>',
              imgs: [
                require('../assets/duna/dunaint1.png'),
                require('../assets/duna/dunaint2.png'),
                require('../assets/duna/dunaint3.png'),
                require('../assets/duna/dunaint4.png'),
                require('../assets/duna/dunaint5.png'),
                require('../assets/duna/dunaint6.png')
              ],
              fachadas: [
                { img: require('../assets/duna/imgdunaa.png'),
                  nombre: 'Fachada Duna A'
                },
                { img: require('../assets/duna/imgdunab.png'),
                  nombre: 'Fachada Duna B'
                },
                { img: require('../assets/duna/imgdunac.png'),
                  nombre: 'Fachada Duna C'
                }
              ]
            },
            sierra: {
              nombre: 'Modelo Sierra',
              descripcion: 'Hermosa casa con todo lo que necesitas. Favor de contactar a un asesor para más información acerca de los acabados que se entregan.',
              caracteristicas: '<ul><li>Construcción: 80.22 m2</li><li>Terreno: 126 m2</li></ul>',
              plantaAlta: '<ul><li>Sala</li><li>Cocina</li><li>Comedor</li><li>Medio baño</li><li>Área de servicio</li><li>Patio trasero</li><li>Estacionamiento 2 autos</li></ul>',
              plantaBaja: '<ul><li>2 recámaras</li><li>2 baños completos</li></ul>',
              imgs: [
                require('../assets/sierra/sierraint1.png'),
                require('../assets/sierra/sierraint2.png'),
                require('../assets/sierra/sierraint3.png'),
                require('../assets/sierra/sierraint4.png'),
                require('../assets/sierra/sierraint5.png'),
                require('../assets/sierra/sierraint6.png'),
                require('../assets/sierra/sierraint7.png'),
              ],
              fachadas: [
                { img: require('../assets/sierra/imgsierraa.png'),
                  nombre: 'Fachada Sierra A'
                },
                { img: require('../assets/sierra/imgsierrab.png'),
                  nombre: 'Fachada Sierra B'
                },
                { img: require('../assets/sierra/imgsierrac.png'),
                  nombre: 'Fachada Sierra C'
                }
              ]
            },
            valle: {
              nombre: 'Modelo Valle',
              descripcion: 'Hermosa casa con todo lo que necesitas. Favor de contactar a un asesor para más información acerca de los acabados que se entregan.',
              caracteristicas: '<ul><li>Construcción: 105.28 m2</li><li>Terreno: 126 m2</li></ul>',
              plantaAlta: '<ul><li>Sala</li>  <li>Cocina</li><li>Comedor</li><li>Medio baño</li><li>Área de servicio</li><li>Patio trasero</li><li>Estacionamiento 2 autos</li></ul>',
              plantaBaja: '<ul><li>3 recámaras</li><li>2 baños completos</li></ul>',
              imgs: [
                require('../assets/valle/valleint1.png'),
                require('../assets/valle/valleint2.png'),
                require('../assets/valle/valleint3.png'),
                require('../assets/valle/valleint4.png'),
                require('../assets/valle/valleint5.png'),
                require('../assets/valle/valleint6.png'),
                require('../assets/valle/valleint7.png')
              ],
              fachadas: [
                { img: require('../assets/valle/imgvallea.png'),
                  nombre: 'Fachada Valle A'
                },
                { img: require('../assets/valle/imgvalleb.png'),
                  nombre: 'Fachada Valle B'
                },
                { img: require('../assets/valle/imgvallec.png'),
                  nombre: 'Fachada Valle C'
                }
              ]
            }
          }, 
          nameFolleto: '',
          emailFolleto: '',
          phoneFolleto:'',
          nameBanner: '',
          emailBanner: '',
          messageBanner: '',
          name: '',
          email: '',
          message: '',
          pet:'',
          messageSend: '',
          messageSendBanner: '',
          messageSendFolleto: '',
          slickOptions: {
            autoplay: true,
            autoplaySpeed: 10000,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            speed: 1000,
          },
      }
  },
  methods: {
    mostrarModelo(index){
      this.modelo = {}
      this.modelo = this.modelos[index]
      this.$refs.bottomEl.scrollIntoView({top: 5000});
    },
    sendMessage: async function(){
      var responseData
      const current = new Date();
      const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
      if(this.name != '' && this.email != '' && this.pet == ''){
        await axios.post('https://api.sheety.co/e553147cf9a67a1f2e3d0f6c773f39bb/cs2ContactCenter/landing', {
          landing: {
            nombre: this.name,
            correo: this.email,
            mensaje: this.message,
            fecha: date
          }
        })
        .then((response) => {
          responseData = response.data
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          /* eslint-enable no-console */
        });
        console.log(responseData);
        if(responseData) {
          this.name = ''
          this.email = ''
          this.message = ''
          this.messageSend = 'Mensaje enviado'
        } else {
          this.messageSend = 'Error al enviar mensaje, intenta mas tarde.'
        }
      } else {
        this.messageSend = 'Ingresa la información necesaria en los campos.'
      }
    },
    sendMessageBanner: async function(){
      var responseData
      const current = new Date();
      const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
      if(this.nameBanner != '' && this.emailBanner != '' && this.pet == ''){
        await axios.post('https://api.sheety.co/e553147cf9a67a1f2e3d0f6c773f39bb/cs2ContactCenter/landing', {
          landing: {
            nombre: this.nameBanner,
            correo: this.emailBanner,
            mensaje: this.messageBanner,
            fecha: date
          }
        })
        .then((response) => {
          responseData = response.data
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          /* eslint-enable no-console */
        });
        console.log(responseData);
        if(responseData) {
          this.nameBanner = ''
          this.emailBanner = ''
          this.messageBanner = ''
          this.messageSendBanner = 'Mensaje enviado'
        } else {
          this.messageSendBanner = 'Error al enviar mensaje, intenta mas tarde.'
        }
      } else {
        this.messageSendBanner = 'Ingresa la información necesaria en los campos.'
      }
    },
    sendDownload: async function(url, title){
      var responseData
      const current = new Date();
      const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
      if(this.nameFolleto != '' && this.emailFolleto != '' && this.phoneFolleto != '' && this.pet == ''){
        await axios.post('https://api.sheety.co/e553147cf9a67a1f2e3d0f6c773f39bb/cs2ContactCenter/landing', {
          landing: {
            nombre: this.nameFolleto,
            correo: this.emailFolleto,
            telefono: this.phoneFolleto,
            fecha: date
          }
        })
        .then((response) => {
          responseData = response.data
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          /* eslint-enable no-console */
        });
        if(responseData) {
          this.nameFolleto = ''
          this.emailFolleto = ''
          this.phoneFolleto = ''
          this.messageSendFolleto = 'Mensaje enviado'
          axios.get(url, {
              responseType: 'arraybuffer'
          }).then(function (response) {
              const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', title)
              document.body.appendChild(link)
              link.click()
          })
          .catch(function (error) {
          /* eslint-disable no-console */
          console.log(error)
          /* eslint-enable no-console */
          })
        } else {
          this.messageSendFolleto = 'Error al enviar mensaje, intenta mas tarde.'
        }
      } else {
        this.messageSendFolleto = 'Ingresa la información necesaria en los campos.'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*  ESTRUCTURA */
.container-fluid .col{
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.highlight{
  color: #6F3E23;
  border: 2px solid #6F3E23;
  font-size: 25px !important;
  font-weight: 500;
  text-align: center;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  padding: 5px 40px;
  border-radius: 50px;
}

.img-fluid{
  width: 100%;
}

/* NAVBAR */
.navbar{
  width: 90%;
  padding: 10px 50px;
  margin: 20px auto 0;
  background: #fff;
  border-radius: 50px;
  box-shadow: 1px 1px 2px #00000020;
}
.navbar-light .navbar-nav .nav-link{
  color: #000000;
  font-weight: 500;
  font-size: 15px;
  padding: 10px 20px;
}
.btn-contacto{
  background: #CDBBA7;
  border-radius: 50px;
}

/* BANNER */
.banner{
  min-height: 100vh;
  background-image: url('../assets/img_banner.png'); /* The image used */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.banner h1{
  font-family: Poppins;
  font-size: 80px;
  font-weight: 600;
  line-height: 120px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #fff;
  text-shadow: 1px 1px 2px #00000060;
  margin-top: 30%;
}
.banner h3{
  font-family: Poppins;
  font-size: 30px;
  font-weight: 600;
  line-height: 45px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #fff;
  text-shadow: 1px 1px 2px #00000060;
}
.form-banner-wrapperout{
  background: #936B3A;
  padding: 15px 20px;
  max-width: 490px;
  border-radius: 20px;
  margin-top: 30%;
}
.form-banner-wrapper{
  background: #FFF;
  padding: 45px 56px;
  border-radius: 20px;
  width: 100% !important;
  max-width: 450px;
  left: 10%;
  z-index: 4;
}
.form-banner-wrapper h4{
  color: #936B3A;
  font-weight: 600;
  font-size: 20px;
}
.form-banner-wrapper .form-control{
  border: 1px solid #CDBBA7;
  height: 65px;
  font-size: 15px;
  margin-bottom: 20px !important;
  border-radius: 5px;
}
.form-banner-wrapper textarea.form-control{
  height: 140px;
}
.btn-enviar-banner{
  background: #936B3A !important;
  color: #FFF !important;
  border-color: #936B3A !important;
  height: 65px;
  width: 100%;
  font-weight: 600;
  font-size: 15px;
}
.error{
  font-weight: 500;
  font-size: 14px !important;
  color: red;
}
.error-input{
  border-color: red !important;
}

/* NOSOTROS */
.nosotros{
  margin-top: 5%;
  margin-bottom: 5%;
  padding-top: 5% ;
  padding-bottom: 5% ;
  background-image: url('../assets/img_nosotros.png'); /* The image used */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  border-radius: 20px;
}
.nosotros p{
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;
}
.nosotros p{
  color: #fff;
}
.nosotros .highlight{
  border-color: #fff;
}

/* MODELO */
.wrapper-modelo{
  position: relative;
}
.wrapper-modelo .btn{
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #CDBBA7 !important;
  border: none !important;
  border-radius: 30px;
  padding: 5px 30px;
  font-size: 25px;
  font-weight: 600;
}
.modelo p{
  font-size: 15px;
  margin-bottom: 10px;
}
.interiores{
  font-weight: 600;
  font-size: 20px !important;
}
.fachadaNombre{
  background: #936B3A;
  color: #fff;
  text-align: center;
  margin-top: 20px;
  font-size: 20px !important;
  font-weight: 500;
  border-radius: 5px;
  padding: 5px 20px;
  max-width: 270px;
  margin-left: auto;
  margin-right: auto;
}

/* FOLLETO */
.folleto-div{
  background: #936B3A;
  border-radius: 20px;
  padding: 20px 40px;
  width: fit-content;
  margin: auto;
}
.folleto-div img{
  max-width: 522px;
}
.folleto-div .btn{
  background: #fff !important;
  border: none;
  width: 100%;
  color: #6F3E23;
  font-size: 25px;
}
.folleto-wrapper{
  background: #CDBBA7;
  border-radius: 20px;
}
.folleto-wrapper .form-control{
  border: 1px solid #CDBBA7;
  height: 65px;
  color: #6F3E23;
  font-size: 20px;
  margin-bottom: 15px !important;
  border-radius: 5px;
}
.folleto-wrapper textarea.form-control{
  height: 140px;
}
.btn-download{
  background: #936B3A !important;
  color: #FFF !important;
  border: none !important;
  height: 65px;
  width: 100%;
  font-weight: 600;
  font-size: 20px;
}
.folleto-col1{
  color: #6F3E23;
  font-weight: 600;
  padding: 5% 7%;
}
.folleto-col2{
  padding: 3%;
  border-radius: 20px;
}

/* COTO CLUB */
.assets{
  padding-top: 7%;
  padding-bottom: 7%;
  color: #6F3E23;
  text-align: center;
}

/* RECOMIENDA Y GANA */
.recomienda{
  padding-top: 7%;
  padding-bottom: 7%;
}

/* CONTACT */
.contacto{
  background: #CDBBA7;
  padding-top: 7% ;
  padding-bottom: 7% ;
  border-top-right-radius: 50px;
  border-top-left-radius: 50px;
  color: #6F3E23;
}
.contacto h2{
  font-size: 50px;
  font-weight: 600;
}
.contacto p{
  font-size: 18px;
  font-weight: 500;
}
.contacto .subtitle{
  font-size: 15px;
}
.contacto iframe{
  border-radius: 30px;
}
.form-wrapper{
  max-width: 360px;
}
.form-wrapper .form-control{
  border: 1px solid #CDBBA7;
  height: 65px;
  font-size: 15px;
  margin-bottom: 20px !important;
  border-radius: 5px;
}
.form-wrapper textarea.form-control{
  height: 140px;
}
.btn-enviar-w{
  background: #fff !important;
  color: #CDBBA7 !important;
  border-color: #fff !important;
  height: 65px;
  width: 100%;
  font-weight: 600;
  font-size: 15px;
}
.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}
.contact-text{
  padding-left: 40px;
  position: relative;
}
.contact-text img{
  position: absolute;
  top: 3px;
  margin-left: -30px;
}
.social-media a{
  margin-right: 10px;
}

/* FOOTER */
.footer{
  padding-top: 35px;
  padding-bottom: 10px;
}
.footer p{
  font-size: 13px;
  color: #948F8F;
  margin-bottom: 0;
}
.footer .aviso,
.footer .aviso a{
  color: #CDBBA7;
}

@media (max-width: 990px) {
  /* BANNER */
  .banner{
    padding-top: 150px;
    padding-bottom: 100px;
  }
  .banner h1{
    font-size: 50px;
    line-height: 60px;
  }
  .banner h3{
    font-size: 25px;
    line-height: 30px;
  }
  .form-banner-wrapper {
    background: #FFF;
    padding: 45px 25px;
  }
  
  /* NOSOTROS */
  .nosotros{
    margin-top: 50px;
    margin-bottom: 50px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    padding-top: 40px;
    padding-bottom: 40px;
  }

  /* MODELO */
  .wrapper-modelo{
    position: relative;
  }
  .wrapper-modelo .btn{
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #CDBBA7 !important;
    border: none !important;
    border-radius: 30px;
    padding: 5px 30px;
    font-size: 25px;
    font-weight: 600;
  }
  .modelo p{
    font-size: 15px;
    margin-bottom: 10px;
  }
  .interiores{
    font-weight: 600;
    font-size: 20px !important;
  }
  .fachadaNombre{
    background: #936B3A;
    color: #fff;
    text-align: center;
    margin-top: 20px;
    font-size: 20px !important;
    font-weight: 500;
    border-radius: 5px;
    padding: 5px 20px;
    max-width: 270px;
    margin-left: auto;
    margin-right: auto;
  }

  /* FOLLETO */
  .folleto{
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .folleto-wrapper{
    background: #CDBBA7;
    border-radius: 20px;
  }
  .folleto-wrapper .form-control{
    border: 1px solid #CDBBA7;
    height: 65px;
    color: #6F3E23;
    font-size: 15px;
    margin-bottom: 15px !important;
    border-radius: 5px;
  }
  .folleto-wrapper textarea.form-control{
    height: 140px;
  }
  .btn-download{
    background: #936B3A !important;
    color: #FFF !important;
    border: none !important;
    height: 65px;
    width: 100%;
    font-weight: 600;
    font-size: 20px;
  }
  .folleto-col1{
    color: #6F3E23;
    font-weight: 600;
    padding: 5% 7%;
  }
  .folleto-col2{
    background: #936B3A;
    padding: 3%;
    border-radius: 20px;
  }

  /* COTO CLUB */
  .assets{
    padding-top: 50px;
    padding-bottom: 50px;
    color: #6F3E23;
    text-align: center;
  }

  .acceso{
  
    padding-top: 50px;
    padding-bottom: 50px;
  }

  /* RECOMIENDA Y GANA */
  .recomienda{
    padding-top: 50px;
    padding-bottom: 50px;
  }

  /* CONTACT */
  .contacto{
    background: #CDBBA7;
    padding-top: 50px ;
    padding-bottom: 50px;
    padding-left: 20px;
    padding-right: 20px;
    border-top-right-radius: 50px;
    border-top-left-radius: 50px;
    color: #6F3E23;
  }
  .contacto h2{
    font-size: 40px;
    font-weight: 600;
  }
  .contacto p{
    font-size: 18px;
    font-weight: 500;
  }
  .contacto .subtitle{
    font-size: 15px;
  }
  .contacto iframe{
    border-radius: 30px;
  }
  .form-wrapper{
    max-width: 100%;
  }
  .form-wrapper .form-control{
    border: 1px solid #CDBBA7;
    height: 65px;
    font-size: 15px;
    margin-bottom: 20px !important;
    border-radius: 5px;
  }
  .form-wrapper textarea.form-control{
    height: 140px;
  }
  .btn-enviar-w{
    background: #fff !important;
    color: #CDBBA7 !important;
    border-color: #fff !important;
    height: 65px;
    width: 100%;
    font-weight: 600;
    font-size: 15px;
  }
  .pet-field{
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      height: 0;
      width: 0;
      z-index: -1;
  }
  .contact-text{
    padding-left: 40px;
    position: relative;
  }
  .contact-text img{
    position: absolute;
    top:3px;
    margin-left: -30px;
  }
  .social-media a{
    margin-right: 15px;
  }

  /* FOOTER */
  .footer{
    padding-top: 35px;
    padding-bottom: 10px;
  }
  .footer p{
    font-size: 13px;
    color: #948F8F;
    margin-bottom: 0;
  }
  .footer .aviso{
    color: #CDBBA7;
  }
}

@media (max-width: 678px){
  .navbar-brand img{
    width: 100px;
  }
  .wrapper-modelo .btn{
    font-size: 20px;
  }
}

/* -------------  WHATSAPP ------------- */
.whatsapp{
    position: fixed;
    bottom: 10px;
    right: 20px;
    width: 60px !important;
}
.whatsapp img{
    width: 100%;
}
</style>
